export const ValidationExceptions = {
	extensionInUse: 'extension-in-use',
	extensionUnsupported: 'extension-unsupported',
	extensionInvalid: 'extension-invalid',
	nameInUse: 'name-in-use',
	scheduleNameInUse: 'schedule-name-in-use',
	nameProvidedTooLong: 'name-too-long',
	nameWasNotProvided: 'name-empty',
};
